<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    width?: number;
    height?: number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    viewBox: '0 0 40 40',
    height: 40,
    width: 40,
    color: '#0F285B',
  }
);

const originalWidth = 40;
const originalHeight = 40;
const aspectRatio = originalWidth / originalHeight;

const computedWidth = computed(() => {
  if (props.width) return props.width;
  if (props.height) return props.height * aspectRatio;
  return originalWidth;
});

const computedHeight = computed(() => {
  if (props.height) return props.height;
  if (props.width) return props.width / aspectRatio;
  return originalHeight;
});
</script>

<template>
  <svg
    :width="computedWidth"
    :height="computedHeight"
    :viewBox="props.viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.3545 36.2641H24.8546C24.5 34.6961 22.509 33.52 20 33.52C17.2364 33.52 15.0728 34.9441 15.0728 36.76C15.0728 38.5759 17.2365 40 20 40C22.1638 40 23.9455 39.12 24.6182 37.8641H31.3454C34.691 37.8641 37.4181 35.4641 37.4181 32.5201V31.736C38.9362 31.144 40 29.808 40 28.256V22.92L39.9998 17.6C39.9998 7.896 31.0271 0 19.9999 0C8.97269 0 0 7.896 0 17.6V28.272C0 30.3761 1.94549 32.08 4.32721 32.08H7.14538C7.64538 32.08 8.05446 31.72 8.05446 31.28V19.92C8.05446 19.48 7.64538 19.12 7.14538 19.12H4.32721C3.39076 19.12 2.52713 19.392 1.81817 19.84V17.6C1.81817 8.77596 9.97268 1.59996 19.9999 1.59996C30.0271 1.59996 38.1816 8.77596 38.1816 17.6V19.84C37.4725 19.392 36.6088 19.12 35.6726 19.12H32.8544C32.3544 19.12 31.9454 19.48 31.9454 19.92V31.28C31.9454 31.72 32.3544 32.08 32.8544 32.08H35.5998V32.5279C35.5998 34.592 33.6907 36.264 31.3545 36.264L31.3545 36.2641ZM20 38.4C18.3456 38.4 16.8911 37.632 16.8911 36.76C16.8911 35.888 18.3456 35.12 20 35.12C21.6545 35.12 23.109 35.888 23.109 36.76C23.109 37.632 21.6545 38.4 20 38.4ZM4.32738 20.72H6.23647V30.48H4.32738C2.94566 30.48 1.81835 29.488 1.81835 28.272V22.936C1.81835 21.712 2.94566 20.72 4.32738 20.72ZM33.7636 20.72H35.6727C37.0544 20.72 38.1817 21.712 38.1817 22.928V28.264C38.1817 29.4799 37.0544 30.4719 35.6727 30.4719H33.7636V20.72Z"
      :fill="props.color"
    />
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
